function tryParseInt<Fallback>(
    value: string | undefined,
    fallback?: Fallback
): Fallback | number | undefined {
    if (typeof value === "undefined") return fallback;
    const parsed = parseInt(value);
    if (isNaN(parsed)) return fallback;
    return parsed;
}

export { tryParseInt };
